// extracted by mini-css-extract-plugin
module.exports = {"datePickerContainer":"task-date-picker_datePickerContainer__eWVEM"};